import {Atom, atom, ExtractAtomValue, useAtomValue} from 'jotai';
import {DependencyList, useMemo} from 'react';

export function useDerived<T extends Atom<any>, U>(
    baseAtom: T,
    selector: (value: ExtractAtomValue<T>) => U,
    deps: DependencyList = []
) {
    return useAtomValue(useDerived$<T, U>(baseAtom, selector, deps));
}

export function useDerived$<T extends Atom<any>, U>(
    base$: T,
    selector: (value: ExtractAtomValue<T>) => U,
    deps: DependencyList = []
): Atom<U> {
    return useMemo(() => {
        return atom(get => {
            const value = get(base$);
            return selector(value);
        });
    }, [...deps, base$]);
}
